var C = Object.defineProperty;
var v = (i, r, e) => r in i ? C(i, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[r] = e;
var f = (i, r, e) => (v(i, typeof r != "symbol" ? r + "" : r, e), e);
var E = /* @__PURE__ */ ((i) => (i.Banner = "banner", i.Card = "card", i.Wide = "wide", i.Login = "login", i.MobileBanner = "mobile-banner", i))(E || {}), T = /* @__PURE__ */ ((i) => (i.Agent = "agent", i.Buyer = "buyer", i.Seller = "seller", i))(T || {}), N = /* @__PURE__ */ ((i) => (i.General = "general", i.FormsBulkFillPeekABoo = "forms-bulk-fill-peek-a-boo", i.FormsBulkFillPopup = "forms-bulk-fill-popup", i.CT2Escrow = "ct2-escrow", i.CT2Title = "ct2-title", i.CT2Commission = "ct2-commission", i))(N || {});
const D = {
  banner: { width: 1214, height: 84 },
  card: { width: 335, height: 296 },
  wide: { width: 472, height: 184 },
  login: { width: 850, height: 850 },
  "mobile-banner": { width: 393, height: 100 }
};
class U {
  /**
   * Constructs an instance of PartnershipAdsServer.
   *
   * @param {object} options - Options for initializing the server.
   * @param {string} options.environment - Environment name ('production', 'staging', 'integ', 'dev').
   * @param {string} [options.accessToken] - Optional access token for authorization.
   */
  constructor({ environment: r, accessToken: e }) {
    f(this, "baseUrl");
    f(this, "headers");
    this.baseUrl = this.getAPIUrl(r), this.headers = {
      "Content-Type": "application/json"
    }, e && (this.headers.Authorization = `Bearer ${e}`);
  }
  /**
   * Gets the appropriate API URL based on the environment.
   *
   * @param {string} environment - Environment name ('production', 'staging', 'integ', 'dev').
   * @returns {string} API URL corresponding to the environment.
   * @private
   */
  getAPIUrl(r) {
    switch (r) {
      case "production":
      case "prod":
        return "https://partnerships.skyslope.com/";
      case "staging":
        return "https://staging-partnerships.skyslope.com/";
      case "integ":
      case "dev":
        return "https://integ-partnerships.skyslope.com/";
      default:
        return "http://localhost:3100/";
    }
  }
  /**
   * Fetches ads from the server based on provided parameters.
   *
   * @param {LoadAdsParams} params - Parameters for filtering ads (e.g., regions).
   * @returns {Promise<PartnerAd[]>} Promise resolving to an array of PartnerAd objects.
   */
  async fetchAds(r) {
    const e = new URLSearchParams(r).toString(), n = await fetch(`${this.baseUrl}partnerships?${e}`, { headers: this.headers });
    if (!n.ok)
      throw new Error(`Failed to fetch partnerships with error: ${await n.text()}`);
    return await n.json();
  }
  /**
   * Tracks an impression for a specific ad using metadata.
   *
   * @param {string} adId - ID of the ad to track impression for.
   * @param {GeneratedMetadata} metadata - Metadata to be sent with the impression tracking request.
   */
  async trackImpression(r, e) {
    await fetch(`${this.baseUrl}i/${r}`, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify(e)
    });
  }
}
function B(i) {
  const r = /^[\u0000-\u00FF]+$/;
  return i.split("").filter(function(e) {
    return r.test(e);
  }).join("");
}
const O = (i) => {
  try {
    return `?m=${btoa(B(JSON.stringify(i ?? {})))}`;
  } catch (r) {
    return console.error(r), "";
  }
}, d = "partner-ads-last-seen", k = "partner-ads-cache-", F = 60 * 5 * 1e3;
class $ {
  /**
   * Create an instance of PartnershipsSDK.
   *
   * @param {PartnerAdsInit} [initParams] - The initialization parameters.
   * @param {string} [initParams.environment='production'] - The environment for the SDK ('integ', 'staging', or 'production').
   * @param {string} [initParams.accessToken] - The access token for authentication. Access token is not required and a blank string can be passed if not available.
   */
  constructor({ environment: r, accessToken: e } = {}) {
    f(this, "server");
    f(this, "ads", []);
    f(this, "loaded", !1);
    /**
     * Load ads from the server and cache them in local storage for 5 minutes.
     * Ads loaded are stored in this class and used for subsequent calls to getAd().
     * Ads returned are filtered on the server by the user's subscriber ID (found in token or params) and user's regions (from params).
     *
     * @param {LoadAdsParams} params - The parameters for loading ads.
     * @returns {Promise<void>} A promise that resolves when ads are successfully loaded and cached.
     * @throws {Error} If there is an issue with loading the ads from the server.
     */
    f(this, "loadAds", async (r = {}) => {
      try {
        const e = localStorage.getItem(k + JSON.stringify(r));
        let n = [], o = !0;
        if (e) {
          const { timestamp: s, data: c } = JSON.parse(e);
          Date.now() - s < F && (n = c, o = !1);
        }
        this.ads = n, this.shuffleAds(), o && await this.updateAdsInBackground(r), this.loaded = !0;
      } catch (e) {
        console.error(e);
      }
    });
    f(this, "updateAdsInBackground", async (r) => {
      try {
        const e = await this.server.fetchAds(r);
        this.ads = e, this.shuffleAds();
        const n = {
          timestamp: Date.now(),
          data: e
        };
        localStorage.setItem(k + JSON.stringify(r), JSON.stringify(n));
      } catch (e) {
        console.error(e);
      }
    });
    this.server = new U({
      environment: r ?? "production",
      accessToken: e
    });
  }
  /**
   * Get the least recently seen ad based on the variant and placement.
   *
   * @param {string} variant - The variant of the ad to be retrieved.
   * @param {string} placement - The placement of the ad within the page or application.
   * @param {function} filterFn - A function used to filter the ads based on custom criteria.
   * @returns {PartnerAd|undefined} The least recently seen ad that matches the criteria, or undefined if no ad matches.
   */
  getAd(r, e = N.General, n = () => !0) {
    var o;
    try {
      const s = Date.now();
      if (!this.loaded) {
        console.error("Ads have not been loaded yet. Please call loadAds() before calling getAd().");
        return;
      }
      const c = sessionStorage.getItem(d), l = JSON.parse(c ?? "{}"), w = this.ads.filter((h) => {
        const g = h.adPlacements.includes(e), y = h.sizes.some((p) => p.type === r), S = n(h);
        return g && y && S;
      });
      w.sort((h, g) => {
        var p, u, A, b;
        const y = parseInt((u = (p = l[h.id]) == null ? void 0 : p[e]) == null ? void 0 : u[r]) || 0, S = parseInt((b = (A = l[g.id]) == null ? void 0 : A[e]) == null ? void 0 : b[r]) || 0;
        return y - S;
      });
      const t = w[0];
      return t ? (l[t.id] = {
        ...l[t.id],
        [e]: { ...((o = l[t.id]) == null ? void 0 : o[e]) ?? {}, [r]: String(s) }
      }, sessionStorage.setItem(d, JSON.stringify(l)), t) : void 0;
    } catch (s) {
      console.error(s);
      return;
    }
  }
  shuffleAds() {
    for (let r = this.ads.length - 1; r > 0; r--) {
      const e = Math.floor(Math.random() * (r + 1));
      [this.ads[r], this.ads[e]] = [this.ads[e], this.ads[r]];
    }
  }
  hasAds() {
    return this.ads.length > 0;
  }
  /**
   * Track an impression for an ad.
   *
   * @param {PartnerAd} ad - The ad for which the impression is being tracked.
   * @param {GeneratedMetadata} metadata - The metadata associated with the impression.
   * @returns {Promise<void>} A promise that resolves when the impression is successfully tracked.
   */
  async trackImpression(r, e) {
    try {
      await this.server.trackImpression(r.id, e);
    } catch (n) {
      console.error(n);
    }
  }
  /**
   * Encode metadata into a query string and append it to the original href.
   *
   * @param {PartnerAd} [ad] - The ad containing the actions from which to generate the href.
   * @param {GeneratedMetadata} [metadata] - The metadata to be encoded into the query string.
   * @returns {string} The generated href with the encoded metadata, or an empty string if an error occurs.
   */
  generateHref(r, e) {
    var n;
    try {
      const o = (n = r == null ? void 0 : r.actions) == null ? void 0 : n.find((c) => c.type === "click");
      return o ? o.href.split("?")[0] + O(e) : "";
    } catch (o) {
      return console.error(o), "";
    }
  }
  /**
   * Generate metadata for tracking.
   *
   * @param {TrackingMetadata} metadata - The metadata object containing information about the ad and user.
   * @returns {Object} The generated metadata for tracking.
   */
  generateMetadata({ ad: r, componentId: e, variant: n, placement: o, ...s }) {
    var c, l, w, t, h, g, y, S, p;
    try {
      const u = (l = (c = r == null ? void 0 : r.actions) == null ? void 0 : c.find((I) => I.type === "click")) == null ? void 0 : l.href, A = new URLSearchParams((u == null ? void 0 : u.split("?")[1]) ?? "").get("url") ?? "", b = location.href;
      return {
        tt: s == null ? void 0 : s.transactionType,
        cd: (w = s == null ? void 0 : s.clientDetails) == null ? void 0 : w.map((I) => ({
          n: I.name,
          e: I.email
        })),
        fa: s != null && s.fileAddress ? {
          sn: (t = s == null ? void 0 : s.fileAddress) == null ? void 0 : t.streetNumber,
          snm: (h = s == null ? void 0 : s.fileAddress) == null ? void 0 : h.streetName,
          c: (g = s == null ? void 0 : s.fileAddress) == null ? void 0 : g.city,
          s: (y = s == null ? void 0 : s.fileAddress) == null ? void 0 : y.state,
          z: (S = s == null ? void 0 : s.fileAddress) == null ? void 0 : S.zip,
          u: (p = s == null ? void 0 : s.fileAddress) == null ? void 0 : p.unit
        } : void 0,
        an: s == null ? void 0 : s.agentName,
        ae: s == null ? void 0 : s.agentEmail,
        r: b,
        id: e,
        url: A,
        s: s == null ? void 0 : s.subscriberId,
        uid: s == null ? void 0 : s.oktaUserId,
        p: o,
        v: n,
        n: s == null ? void 0 : s.userName,
        e: s == null ? void 0 : s.userEmail,
        hid: s == null ? void 0 : s.heapUserId
      };
    } catch (u) {
      return console.error(u), {};
    }
  }
}
export {
  T as PartnerAdAudience,
  N as PartnerAdPlacement,
  E as PartnerAdVariant,
  D as PartnerVariantDefaultSizes,
  $ as PartnershipsSDK,
  O as generateQueryString
};
